
import { useEffect, useState } from "react";
import { getFinancialReports } from "../services/financialService";
import CustomerFinancialReport from "./CustomerFinancialReport";
import PaymentsTable from "./PaymentsTable";
import { Swiper, SwiperSlide } from "swiper/react";

import { Info, Clock3, Package } from "lucide-react";
import "swiper/css";
import "../styles/FinancialReport.css";


export default function FinancialReport() {
    const [report, setReport] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");



    const [activeTab, setActiveTab] = useState("financialReporting");


    const tabs = [
        {
            key: "financialReporting",
            label: "گزارش مشتریان",
            field: "financialReport",
            icon: Info,
        },
        {
            key: "paying",
            label: "واریزی ها",
            field: "paid",
            icon: Clock3,
        },
        {
            key: "transaction",
            label: "تراکنش مشاوره",
            field: "transaction",
            icon: Package,
        },
    ];



    useEffect(() => {
        let active = true;

        const loadReport = async () => {

            try {

                setLoading(true);

                const response = await getFinancialReports();
                if (active) {
                    setReport(response);
                }

            } catch (error) {

                console.error("Failed to load Orders:", error);

                setError("Orders not found.");

            } finally {

                if (active) setLoading(false);
            }
        };

        loadReport();

    }, []);

    // Use your existing API response state here.
    const orders = report?.orders ?? [];
    const payments = report?.payments ?? [];
    const userPayments = report?.userPayments ?? [];



    const summary = report?.summary ?? {
        totalPrice: 0,
        totalScore: 0,
        totalShareAmount: 0,
    };

    if (loading) {
        return (
            <div className="financial-status" dir="rtl">
                در حال دریافت گزارش مالی...
            </div>
        );
    }

    if (error) {
        return (
            <div className="financial-error" dir="rtl">
                {error}
                <button onClick={() => window.location.reload()}>
                    تلاش مجدد
                </button>
            </div>
        );
    }



    return (
  <div className="wrapper">
      <h2>
        <span> گزارش مالی </span>
      </h2>

      {/* Tabs */}
      <div className="orderTabsTitle">
        <Swiper
          dir="rtl"
          slidesPerView={"auto"}
          spaceBetween={1}
          className="order-tabs-swiper"
        >
          {tabs.map((tab) => (
            <SwiperSlide
              className="!w-auto"
              key={tab.key}
              style={{ width: "auto" }}
            >
              <button
                onClick={() => setActiveTab(tab.key)}
                className={`order-tab ${activeTab === tab.key ? "active" : ""}`}
              >
                <span>{tab.label}</span>

             
              </button>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

             <div className="report-tab-content">
                {activeTab === "financialReporting" && (
                    <CustomerFinancialReport
                        orders={orders}
                        summary={summary}
                    />
                )}

                {activeTab === "paying" && (
                    <PaymentsTable payments={payments} />
                )}

                {activeTab === "transaction" && (
                    <PaymentsTable
                        payments={userPayments}
                        title="تراکنش مشاوره"
                        transactionMode
                    />
                )}
            </div>


    </div>


    
    );


}
